import { render } from "./ProductModifyWindow.vue?vue&type=template&id=8df0969a&scoped=true"
import script from "./ProductModifyWindow.vue?vue&type=script&lang=js"
export * from "./ProductModifyWindow.vue?vue&type=script&lang=js"

import "./ProductModifyWindow.vue?vue&type=style&index=0&id=8df0969a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8df0969a"]])

export default __exports__